import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { B as Button } from '../../Button/Button-Cwlb3sfd.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { l as angleDown } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { I as Icon } from '../../Icon/Icon-CoM8rI0H.js';

const MenuButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-40026394__sc-uwares-0"
})(["width:", ";"], ({
  $fullWidth
}) => $fullWidth ? '100%' : 'auto');
const MenuButtonTriggerIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40026394__sc-uwares-1"
})(["margin-inline-end:0;pointer-events:none;"]);
MenuButtonTriggerIcon.displayName = 'MenuButtonTriggerIcon';
const MenuButtonTrigger = /*#__PURE__*/forwardRef(({
  children,
  disabled,
  variant,
  taktId,
  fullWidth,
  ...rest
}, ref) => /*#__PURE__*/React__default.createElement(MenuButton, _extends({}, rest, {
  disabled: disabled,
  buttonRef: ref,
  variant: variant,
  taktId: taktId !== null && taktId !== void 0 ? taktId : createStormTaktId('menu-button'),
  $fullWidth: fullWidth
}), children, /*#__PURE__*/React__default.createElement(MenuButtonTriggerIcon, {
  type: angleDown
})));

export { MenuButtonTrigger as M };
//# sourceMappingURL=MenuButtonTrigger-RinFQ5FR.js.map
